export const moderationReportConstants = {
  GET_MODERATION_FLAG_REASONS_REQUEST: 'MODERATION/GET_MODERATION_FLAG_REASONS_REQUEST',
  GET_MODERATION_FLAG_REASONS_SUCCESS: 'MODERATION/GET_MODERATION_FLAG_REASONS_SUCCESS',
  GET_MODERATION_FLAG_REASONS_FAILURE: 'MODERATION/GET_MODERATION_FLAG_REASONS_FAILURE',

  GET_MODERATION_INFO_REQUEST: 'MODERATION/GET_MODERATION_INFO_REQUEST',
  GET_MODERATION_INFO_SUCCESS: 'MODERATION/GET_MODERATION_INFO_SUCCESS',
  GET_MODERATION_INFO_FAILURE: 'MODERATION/GET_MODERATION_INFO_FAILURE',

  ADD_FLAG_REQUEST: 'MODERATION/ADD_FLAG_REQUEST',
  ADD_FLAG_SUCCESS: 'MODERATION/ADD_FLAG_SUCCESS',
  ADD_FLAG_FAILURE: 'MODERATION/ADD_FLAG_FAILURE',

  ACTION_FLAG_REQUEST: 'MODERATION/ACTION_FLAG_REQUEST',
  ACTION_FLAG_SUCCESS: 'MODERATION/ACTION_FLAG_SUCCESS',
  ACTION_FLAG_FAILURE: 'MODERATION/ACTION_FLAG_FAILURE',

  SUSPEND_REQUEST: 'MODERATION/SUSPEND_REQUEST',
  SUSPEND_SUCCESS: 'MODERATION/SUSPEND_SUCCESS',
  SUSPEND_FAILURE: 'MODERATION/SUSPEND_FAILURE',

  VALIDATE_REQUEST: 'MODERATION/VALIDATE_REQUEST',
  VALIDATE_SUCCESS: 'MODERATION/VALIDATE_SUCCESS',
  VALIDATE_FAILURE: 'MODERATION/VALIDATE_FAILURE',

  REINSTATE_REQUEST: 'MODERATION/REINSTATE_REQUEST',
  REINSTATE_SUCCESS: 'MODERATION/REINSTATE_SUCCESS',
  REINSTATE_FAILURE: 'MODERATION/REINSTATE_FAILURE',

  CLEAR_SUSPEND_DATA: 'MODERATION/CLEAR_SUSPEND_DATA'
}
